<div *ngIf="isLoading" class="ui active inverted dimmer">
    <div class="ui loader"></div>
</div>

<form #form="ngForm">
    <div class="app-grid">
        <!-- Name -->
        <mat-form-field class="columns-6">
            <mat-label>{{ 'forms.fields.name' | translate }}</mat-label>
            <input
                matInput
                type="text"
                name="title"
                #name="ngModel"
                [(ngModel)]="field.name"
                placeholder="{{ 'forms.fields.egLicenseNumber' | translate }}"
                required
            />
            <mat-error *ngIf="name.invalid">{{ name.errors | formErrors }}</mat-error>
        </mat-form-field>

        <!-- Description -->
        <mat-form-field class="columns-6">
            <mat-label>{{ 'forms.fields.placeholderText' | translate }}</mat-label>
            <input
                matInput
                name="placeholderText"
                [(ngModel)]="field.description"
                #description="ngModel"
                required
                [disabled]="placeholderInputDisabled"
            />
            <mat-error *ngIf="description.invalid">{{ description.errors | formErrors }}</mat-error>
        </mat-form-field>

        <!-- Field Encryption -->
        <div class="columns-6">
            <mat-label
                >{{ 'forms.fields.fieldEncryption' | translate }}
                <ui-info
                    class="margin-left-1"
                    text="{{ 'forms.fields.humiEncouragesFieldEncryptionForCustomFieldsContainingSe' | translate }}"
                ></ui-info>
            </mat-label>
            <mat-radio-group
                class="margin-bottom-2 vertical"
                name="encrypt"
                [(ngModel)]="field.isEncrypted"
                #encrypt="ngModel"
                aria-label="Encrypt This Field? Use for sensitive data."
                required
            >
                <mat-radio-button [value]="true">{{ 'forms.fields.yes' | translate }}</mat-radio-button>
                <mat-radio-button [value]="false">{{ 'forms.fields.no' | translate }}</mat-radio-button>
            </mat-radio-group>
            <mat-error *ngIf="encrypt.invalid">{{ encrypt.errors | formErrors }}</mat-error>
        </div>

        <!-- Required -->
        <div class="columns-6">
            <mat-label
                >{{ 'forms.fields.requiredField' | translate }}
                <ui-info
                    class="margin-left-1"
                    text="{{ 'forms.fields.aRequiredCustomFieldMeansThatItMustBeFilledOut' | translate }}"
                ></ui-info>
            </mat-label>
            <mat-radio-group
                class="margin-bottom-2 vertical"
                name="isRequired"
                [(ngModel)]="field.isRequired"
                #fieldType="ngModel"
                aria-label="Required? Must be filled out"
                required
            >
                <mat-radio-button [value]="true">{{ 'forms.fields.yes' | translate }}</mat-radio-button>
                <mat-radio-button [value]="false">{{ 'forms.fields.no' | translate }}</mat-radio-button>
            </mat-radio-group>
            <mat-error *ngIf="fieldType.invalid">{{ fieldType.errors | formErrors }}</mat-error>
        </div>

        <!-- Roles -->
        <div class="columns-12" [ngClass]="{ 'margin-bottom-3': form.submitted && field.roles.length === 0 }">
            <input
                name="roleAutocomplete"
                type="hidden"
                [(ngModel)]="field.roles"
                [required]="field.roles.length === 0"
                #roleAutocomplete="ngModel"
            />

            <ui-chips-autocomplete
                class="margin-bottom-0"
                [label]="'forms.fields.rolesWithThePermissionnbspToEditAndView' | translate"
                placeholder="Select all that apply"
                [allowHtmlLabel]="true"
                [autocompleteItems]="selectableRoles"
                [selectedItems]="field.roles"
                (changes)="onRoleChange($event)"
            ></ui-chips-autocomplete>

            <mat-error style="margin-top: -18px" *ngIf="form.submitted && field.roles.length === 0">{{
                'forms.fields.thisFieldIsRequired' | translate
            }}</mat-error>
        </div>

        <div class="columns-12">
            <ui-chips-autocomplete
                [label]="'forms.fields.rolesWithThePermissionnbspToOnlyView' | translate"
                placeholder="Select all that apply"
                [allowHtmlLabel]="true"
                [autocompleteItems]="viewOnlySelectableRoles"
                [selectedItems]="field.viewOnlyRoles"
                (changes)="onViewOnlyRoleChange($event)"
            ></ui-chips-autocomplete>
        </div>
    </div>

    <div class="app-grid">
        <!-- Group -->
        <div class="columns-4">
            <mat-form-field class="width-full">
                <mat-label appRemoveAriaOwns>{{ 'forms.fields.fieldGroup' | translate }}</mat-label>
                <mat-select
                    placeholder="{{ 'forms.fields.pleaseSelectAnOption' | translate }}"
                    [(ngModel)]="group"
                    #fieldGroupName="ngModel"
                    name="fieldGroup"
                    required
                >
                    <mat-select-trigger *ngIf="group?.isPersisted">{{ group?.name }}</mat-select-trigger>
                    <mat-select-trigger *ngIf="!group?.isPersisted">{{
                        'forms.fields.addNewGroup' | translate
                    }}</mat-select-trigger>
                    <mat-option [value]="stagedGroup" class="create font-medium">
                        <span>{{ 'forms.fields.addNewGroup' | translate }}</span>
                    </mat-option>
                    <mat-option *ngFor="let fieldGroup of fieldGroups" [value]="fieldGroup">
                        <div class="option-body">
                            <span>{{ fieldGroup.translatableName | translate }}</span>
                            <span class="sub-label"> {{ fieldGroup.translatableComponent | translate }} </span>
                        </div>
                    </mat-option>
                </mat-select>

                <mat-error *ngIf="fieldGroupName.invalid">{{ fieldGroupName.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>

        <div class="columns-1 flex align-items-center justify-center">
            <ui-info
                text="{{ 'forms.fields.thisIsWhereTheCustomFieldWillAppearOnInTheEmployeesP' | translate }}"
            ></ui-info>
        </div>

        <!-- Group Name -->
        <div class="columns-3">
            <ng-container *ngIf="group === stagedGroup">
                <mat-form-field class="width-full">
                    <mat-label>{{ 'forms.fields.groupName' | translate }}</mat-label>
                    <input
                        matInput
                        type="text"
                        name="fieldGroupName"
                        #groupName="ngModel"
                        [(ngModel)]="group.name"
                        required
                    />
                    <mat-error *ngIf="groupName.invalid">{{ groupName.errors | formErrors }}</mat-error>
                </mat-form-field>
            </ng-container>
        </div>

        <!-- Group Location -->
        <div class="columns-3">
            <ng-container *ngIf="group === stagedGroup">
                <mat-form-field class="width-full" [ngClass]="{ maskedGroupComponent: componentFilter }">
                    <mat-label appRemoveAriaOwns>{{ 'forms.fields.groupLocation' | translate }}</mat-label>
                    <mat-select
                        placeholder="{{ 'forms.fields.pleaseSelectAnOption' | translate }}"
                        #groupComponent="ngModel"
                        name="groupComponent"
                        [(ngModel)]="group.component"
                        [disabled]="componentFilter !== null"
                        required
                    >
                        <mat-option value="personal">{{ 'forms.fields.personal' | translate }}</mat-option>
                        <mat-option value="job_and_pay">{{ 'forms.fields.jobAndPay' | translate }}</mat-option>
                    </mat-select>
                    <mat-error *ngIf="groupComponent.invalid">{{ groupComponent.errors | formErrors }}</mat-error>
                </mat-form-field>
            </ng-container>
        </div>
    </div>

    <div class="app-grid">
        <!-- Type -->
        <div class="columns-4">
            <mat-form-field class="width-full">
                <mat-label appRemoveAriaOwns>{{ 'forms.fields.fieldType' | translate }}</mat-label>
                <mat-select
                    placeholder="{{ 'forms.fields.pleaseSelectAnOption' | translate }}"
                    [(ngModel)]="field.type"
                    (selectionChange)="onTypeChange()"
                    #rule="ngModel"
                    name="selectedId"
                    required
                >
                    <mat-option [value]="dataFieldTypes.shortText">{{
                        'forms.fields.shortText' | translate
                    }}</mat-option>
                    <mat-option [value]="dataFieldTypes.number">{{ 'forms.fields.number' | translate }}</mat-option>
                    <mat-option [value]="dataFieldTypes.date">{{ 'forms.fields.date' | translate }}</mat-option>
                    <mat-option [value]="dataFieldTypes.boolean">{{ 'forms.fields.yesNo' | translate }}</mat-option>
                    <mat-option [value]="dataFieldTypes.dropdown">{{ 'forms.fields.dropdown' | translate }}</mat-option>
                    <mat-option [value]="dataFieldTypes.longText">{{ 'forms.fields.longText' | translate }}</mat-option>
                </mat-select>

                <mat-error *ngIf="rule.invalid">{{ rule.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>

        <div class="columns-1 flex align-items-center justify-center">
            <ui-info
                text="{{ 'forms.fields.thisIsWhatTypeOfInformationTheEmployeeWillInputInThe' | translate }}"
            ></ui-info>
        </div>

        <!-- Min Length -->
        <div class="columns-3">
            <ng-container *ngIf="hasMinMax">
                <mat-form-field class="width-full">
                    <mat-label *ngIf="field.type !== dataFieldTypes.number">{{
                        'forms.fields.minimumLength' | translate
                    }}</mat-label>
                    <mat-label *ngIf="field.type === dataFieldTypes.number">{{
                        'forms.fields.minimumValue' | translate
                    }}</mat-label>
                    <input
                        matInput
                        type="number"
                        name="fieldTypeExtraMinLength"
                        [(ngModel)]="field.min"
                        #minLength="ngModel"
                    />
                </mat-form-field>
            </ng-container>
        </div>

        <!-- Max Length -->
        <div class="columns-3">
            <ng-container *ngIf="hasMinMax">
                <mat-form-field class="width-full">
                    <mat-label *ngIf="field.type !== dataFieldTypes.number">{{
                        'forms.fields.maximumLength' | translate
                    }}</mat-label>
                    <mat-label *ngIf="field.type === dataFieldTypes.number">{{
                        'forms.fields.maximumValue' | translate
                    }}</mat-label>
                    <input
                        matInput
                        type="number"
                        name="fieldTypeExtraMaxLength"
                        [(ngModel)]="field.max"
                        #maxLength="ngModel"
                    />
                </mat-form-field>
            </ng-container>
        </div>
    </div>

    <!-- Dropdown options -->
    <ng-container *ngIf="field.type === dataFieldTypes.dropdown">
        <div class="app-grid margin-bottom-2">
            <div class="columns-12 flex justify-space-between">
                <mat-label class="add-asterisk">{{ 'forms.fields.dropdownOptions' | translate }}</mat-label>
                <ng-container *ngIf="dataFieldOptionState.dataFieldOptions.length === 1; else multipleDropdownOptions">
                    <mat-label class="field-options-description margin-left-5">{{
                        {
                            key: 'forms.fields.dataFieldOptionStatedataFieldOptionslengthOptionInList',
                            params: {
                                length: dataFieldOptionState.dataFieldOptions.length,
                            },
                        } | appTranslate
                    }}</mat-label>
                </ng-container>
                <ng-template #multipleDropdownOptions>
                    <mat-label class="field-options-description margin-left-5">{{
                        {
                            key: 'forms.fields.dataFieldOptionStatedataFieldOptionslengthOptionsInList',
                            params: {
                                length: dataFieldOptionState.dataFieldOptions.length,
                            },
                        } | appTranslate
                    }}</mat-label>
                </ng-template>
            </div>
        </div>

        <div class="app-grid margin-bottom-1">
            <app-drag-and-drop-with-deletable-options
                class="columns-12"
                addBorder="true"
                addButtonLabel="Add Dropdown Option"
                maxOptions="50"
                [hideRemoveOnOneItem]="true"
                [emptyOption]="getEmptyDataFieldOption()"
                [options]="dataFieldOptionState.dataFieldOptions"
                (optionsChange)="dataFieldOptionState.trackOptionChanges($event)"
                (optionRemoved)="onOptionRemove($event)"
            ></app-drag-and-drop-with-deletable-options>
        </div>
    </ng-container>
</form>
